import { Badge, Layout, Menu } from "antd";
import React, { useEffect, useState } from "react";
import "./style.scss";
import { useHistory } from "react-router-dom";
import { MenuUnfoldOutlined, MenuFoldOutlined } from "@ant-design/icons";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import Logo from "../../../images/logo.svg";
import logoSm from "../../../images/logoSm.svg";
import {
  FaMapMarkedAlt,
  FaUserTie,
  FaBuilding,
  FaBoxes,
  FaBell,
  FaPercent,
} from "react-icons/fa";
import { useSelector } from "react-redux";
import en from "../../../localization/en";
import ar from "../../../localization/ar";
const { SubMenu } = Menu;
const { Sider } = Layout;

const rootSubmenuKeys = [
  "Dashboard",
  "Profile",
  "Reports",
  "2",
  "Subscription",
  "Orders",
];

export const SideBar = () => {
  const [collapsed, setCollapsed] = useState(true);
  const [openKeysState, setOpenKeys] = useState(["Dashboard"]);
  const toggle = () => setCollapsed(!collapsed);
  const history = useHistory();
  const { pathname } = useLocation();
  const handleRouteToComponent = (route) => history.push(route);
  const { currentLang } = useSelector((state) => state?.user);
  const t = currentLang === "en" ? en : ar;

  useEffect(() => {
    if (document.getElementsByClassName("ant-layout-content")[0])
      document.getElementsByClassName("ant-layout-content")[0].scrollTop = 0;
  }, [pathname]);

  const onOpenChange = (openKeys) => {
    const latestOpenKey = openKeys.find(
      (key) => openKeysState.indexOf(key) === -1
    );

    if (rootSubmenuKeys.indexOf(latestOpenKey) === -1) setOpenKeys(openKeys);
    else setOpenKeys(latestOpenKey ? [latestOpenKey] : []);
  };

  const handleCloseSubMenu = (openKey) => setOpenKeys([openKey]);

  return (
    <Sider
      className={collapsed ? "collapsed" : "open"}
      trigger={null}
      collapsible
      collapsed={collapsed}
    >
      <div className="logo__wrapper">
        <p>
          {collapsed ? (
            <img src={logoSm} alt="Logo" />
          ) : (
            <img src={Logo} alt="logo" />
          )}
        </p>
        <span className="collapse-icon" onClick={toggle}>
          {collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
        </span>
      </div>
      <Menu
        openKeys={openKeysState}
        onOpenChange={onOpenChange}
        theme="dark"
        mode="inline"
        defaultSelectedKeys={["1"]}
      >
        <Menu.Item
          onClick={() => {
            handleRouteToComponent("/dashboard");
            handleCloseSubMenu("Dashboard");
          }}
          key="Dashboard"
          icon={<img src="/images/leftMenu/dashboard.svg" alt="Dashboard" />}
        >
          <p>{t.Dashboard}</p>
        </Menu.Item>
        <Menu.Item
          onClick={() => {
            handleRouteToComponent("/notification");
            handleCloseSubMenu("notification");
          }}
          key="notification"
          icon={
            <FaBell />

            // <Badge count={5} offset={[-10, 0]}>
            // 	<FaBell />
            // </Badge>
          }
        >
          <p>{t.Notifications}</p>
        </Menu.Item>
        <Menu.Item
          onClick={() => {
            handleRouteToComponent("/profile/PersonalInfo");
            handleCloseSubMenu("companyInfo");
          }}
          key="companyInfo"
          icon={<FaBuilding />}
        >
          <p> {t.Companyinfo}</p>
        </Menu.Item>
        {/* <SubMenu key="Profile" icon={<FaBuilding />} title={<p>Profile <span>الحساب</span> </p>}>
					<Menu.Item onClick={() => handleRouteToComponent("/profile/PersonalInfo")} key="companyInfo">
						<p>Company info <span>
							بيانات الشركة</span></p>
					</Menu.Item>
				</SubMenu> */}

        {/* <SubMenu key="Reports" icon={<img src='/images/leftMenu/reports.svg' alt='Reports' />} title={<p>Reports <span>التقارير</span> </p>}>
					<Menu.Item onClick={() => handleRouteToComponent("/reports/userLeads")} key="Unique">
						<p>Unique Leads <span>العملاء</span></p>
					</Menu.Item>
					<Menu.Item onClick={() => handleRouteToComponent("/reports/info-view")} key="Viewed">
						<p> Info Viewed <span>اظهار البيانات</span></p>
					</Menu.Item>
					<Menu.Item onClick={() => handleRouteToComponent("/reports/callBack")} key="Call">
						<p>Call back <span>طلب الاتصال</span></p>
					</Menu.Item>
					<Menu.Item onClick={() => handleRouteToComponent("/reports/product")} key="RFQ">
						<p>Product RFQ <span>طلب سعر المنتج</span></p>
					</Menu.Item>
				</SubMenu> */}

        {/* <Menu.Item onClick={() => {
					handleRouteToComponent("/messages");
					handleCloseSubMenu('Message')
				}} key="Message" icon={<img src='/images/leftMenu/Message.svg' alt='Message' />}>
					<p>Messages <span>الرسائل</span></p>
				</Menu.Item> */}

        {/* <SubMenu key="Subscription" icon={<img src='/images/leftMenu/subscriptions.svg' alt='Subscriptions' />} title={<p>Subscription <span>الاشتراك</span> </p>}>
					<Menu.Item onClick={() => handleRouteToComponent("/subscription/mySubscription")} key="mySubscription">
						<p>My Subscription <span>اشتراكي</span></p>
					</Menu.Item>
					<Menu.Item onClick={() => handleRouteToComponent("/subscription/purchase")} key="Extras">
						<p> Extras <span>باقات اضافية</span></p>
					</Menu.Item>
					<Menu.Item onClick={() => handleRouteToComponent("/subscription/history")} key="History">
						<p>History <span>تفاصيل المعاملات</span></p>
					</Menu.Item>
					<Menu.Item onClick={() => handleRouteToComponent("/subscription/my-history-sub")} key="SubscriptionHistory">
						<p><span style={{ lineHeight: '16px' }}> Subscription <br /> History </span><span>الاشتراكات السابقة</span></p>
					</Menu.Item>
				</SubMenu> */}
        <Menu.Item
          onClick={() => {
            handleRouteToComponent("/order");
            handleCloseSubMenu("Orders");
          }}
          key="Orders"
          icon={<FaMapMarkedAlt />}
        >
          <p> {t.Orders}</p>
        </Menu.Item>

        <Menu.Item
          onClick={() => {
            handleRouteToComponent("/Chauffeurs");
            handleCloseSubMenu("Chauffeurs");
          }}
          icon={<FaUserTie />}
          key="Chauffeurs"
        >
          <p> {t.Chauffeurs}</p>
        </Menu.Item>

        <Menu.Item
          onClick={() => {
            handleRouteToComponent("/offers");
            handleCloseSubMenu("offers");
          }}
          icon={<FaPercent />}
          key="offers"
        >
          <p> {t.offers}</p>
        </Menu.Item>
        {/* 
				<Menu.Item
				onClick={() => {
					handleRouteToComponent('/packages');
					handleCloseSubMenu('packages')
				}} 
				icon={<FaBoxes />} key="packages">
					<p>packages <span>الحزم</span></p>
				</Menu.Item> */}

        {/* <Menu.Item
				onClick={() => {
					handleRouteToComponent('/reports/userLeads');
					handleCloseSubMenu('Customers')
				}} 
				icon={<FaUserFriends />} key="Customers">
					<p>Customers <span>العملاء</span></p>
				</Menu.Item> */}
      </Menu>
    </Sider>
  );
};
